import React from "react";
import "./Header.css";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();

  const navigateToPage = (navigateTo) => {
    navigate(navigateTo);
  };

  return (
    <header className="header-app">
      <p className="header-title" onClick={() => navigateToPage("/")}>
        GIOVANNA OHL
      </p>
      <div className="header-menu">
        <p
          onClick={() => {
            window.scrollTo({ top: 0, left: 0, behavior: "instant" });
            navigateToPage("/");
          }}
        >
          works.
        </p>
        <p onClick={() => navigateToPage("/contact")}>contact.</p>
      </div>
    </header>
  );
};

export default Header;
